import React from 'react';
import PropTypes from 'prop-types';
import {Offcanvas, OffcanvasBody, OffcanvasHeader} from "reactstrap5";
import {FormattedMessage} from "react-intl";
import classnames from "classnames";
import ActivityList from "../../../../frontend/react/ActivityList";
import Lottie from "react-lottie";
import VikyAnimation from "../../VikyAnimation";
import VikyAnimationJson from "../../../../frontend/animation/viky_anim_face_icon.json";

class RecommendationsOffcanvas extends React.Component {
    render() {
        const {recommendationActivities, close, colourTheme, activityDetail} = this.props;

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: VikyAnimationJson,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };

        return (
            <Offcanvas direction={activityDetail ? "end" : "bottom"} fade={!activityDetail} backdrop={!activityDetail} className={"rounded-top rounded-2 recommendation " + (colourTheme || "fyzika") + "--primary text-" + (colourTheme !== "white" ? "white" : "black") + " " + (activityDetail ? "activity-offcanvas" : "")} isOpen={true} toggle={close}>
                <OffcanvasHeader className={'text-center'} toggle={close}>
                    {activityDetail && <div className={"mb-2"}><VikyAnimation /></div>}
                    <FormattedMessage
                        defaultMessage='VIKY DOPORUČUJE'/>
                </OffcanvasHeader>
                <OffcanvasBody className={classnames('d-md-flex align-content-center flex-column', {'flex-md-row justify-content-center': !activityDetail})}>

                    {!activityDetail && <div className={classnames('offcanvas-info-box p-2 text-center', {'order-2 order-md-1 text-md-start d-none d-lg-flex': !activityDetail})}>
                        <div className="text-15 pb-3">
                            <div className="viky-animation"><Lottie options={defaultOptions} /></div>
                            <FormattedMessage defaultMessage='VIKY DOPORUČUJE'/>
                        </div>
                        <p className="text-14">
                            <FormattedMessage
                                defaultMessage='Ahoj, jsem Viky! Vaše osobní AI kámoška. Pozorovala jsem, jak procvičujete a mám pro Vás tipy, co procvičit dále, abyste si zlepšili skóre. Zajímá Vás to?'/>
                        </p>
                    </div>}

                    <div className={classnames('d-flex flex-column', {'flex-md-row order-1 order-md-2 align-items-md-center': !activityDetail})}>
                        <ActivityList activities={recommendationActivities} colourTheme={colourTheme !== "white" ? colourTheme : null} />
                    </div>
                </OffcanvasBody>
            </Offcanvas>
        );
    }
}

RecommendationsOffcanvas.propTypes = {
    recommendationActivities: PropTypes.array.isRequired,
    close: PropTypes.func.isRequired,
    colourTheme: PropTypes.string,
    activityDetail: PropTypes.bool,
};

export default RecommendationsOffcanvas;